module.exports = __webpack_public_path__ + "static/img/9.207b82a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/9.png
// module id = 7H3w
// module chunks = 0